export default "__VITE_ASSET__wkINkr1ClyKO3k6Zht3DXg__"